import { render, staticRenderFns } from "./TranslationUploadItem.vue?vue&type=template&id=b18b0370&"
import script from "./TranslationUploadItem.vue?vue&type=script&lang=ts&"
export * from "./TranslationUploadItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports